import {createSlice, PayloadAction, createSelector} from '@reduxjs/toolkit';
import type {RootState} from '../../types';
import type {PromotionsState} from './types';

const promotionSelector = (state: RootState) => state.promotions;

export const promotionsSlice = createSlice({
	name: 'promotions',
	initialState: {},
	reducers: {
		receivePromotions: (state: PromotionsState, action: PayloadAction<PromotionsState>) => {
			Object.assign(state, action.payload);
		},
		cleanupPromotions: (_state: PromotionsState) => {
			return {};
		}
	}
});

export const {receivePromotions, cleanupPromotions} = promotionsSlice.actions;

export const selectPromotions = createSelector(promotionSelector, (promotions) => promotions);

const selectPromotionId = (state, promotionId) => promotionId;

export const selectPromotion =
	createSelector([selectPromotions, selectPromotionId], (promotions, promotionId) => promotions[promotionId]);

export default promotionsSlice.reducer;
